import { ADDRESS_COUNTRY_CODE, ADDRESS_COUNTRY_NAME } from 'settings/address-location';
import { getDefaultCoordinatesByCountry } from 'utils/getDefaultCoordinatesByCountry';
import { IAddress } from 'lib/dfl-address-form-mui/interfaces';

export const ADDRESS_INIT_VALUE: IAddress = {
  address1: '',
  address1Name: '',
  address2: '',
  address2Name: '',
  houseNumber: '',
  formattedAddress: '',
  city: '',
  cityName: '',
  state: '',
  stateName: '',
  country: ADDRESS_COUNTRY_CODE,
  countryName: ADDRESS_COUNTRY_NAME,
  zipCode: '',
  location: {
    type: 'Point',
    coordinates: getDefaultCoordinatesByCountry(),
  },
};
